import React from 'react';
import PropTypes from 'prop-types';

const Tabs = ({ activeTab, setActiveTab, isDocumentUploaded }) => (
  <div className="flex bg-pl_bg_light_2 rounded-full p-1 w-full max-w-xl mx-auto mb-5 shadow-sm">
    <button
      className={`flex-1 py-2 px-4 sm:px-4 xs:py-1 rounded-full text-base font-semibold transition-all duration-200 focus:outline-none ${
        activeTab === 'Document Translation'
          ? 'bg-pl_prim_color_1 text-white shadow'
          : 'bg-transparent text-pl_txt_light_2 hover:bg-pl_bg_light_3'
      }`}
      onClick={() => setActiveTab('Document Translation')}
    >
      Document 
    </button>
    <button
      className={`flex-1 py-2 px-4 xs:py-1 rounded-full text-base font-semibold transition-all duration-200 focus:outline-none ${
        activeTab === 'Text Playground'
          ? 'bg-pl_prim_color_1 text-white shadow xs:py-1'
          : 'bg-transparent text-pl_txt_light_2 xs:py-1 hover:bg-pl_bg_light_3'
      } ${isDocumentUploaded ? 'opacity-50 cursor-not-allowed' : ''}`}
      onClick={() => !isDocumentUploaded && setActiveTab('Text Playground')}
      disabled={isDocumentUploaded}
    >
      Text
    </button>
  </div>
);

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  isDocumentUploaded: PropTypes.bool.isRequired,
};

export default Tabs;
